<script>
  import { AppController } from '../AppController.js';
  import SectionHeader from '../components/SectionHeader.svelte';
  import { toast } from '../components/Toast.svelte';
  import { showLoading } from '../components/Overlay.svelte';

  import { fade } from 'svelte/transition';
  import { form } from '../validate.js';
  import { push } from 'svelte-spa-router';
  import { to_number } from 'svelte/internal';
 
  // data
  let user = AppController.getUser();
  let subsection = 'Account'
  let verifyPassword = user.password;

  const { validate, ...userForm} = form(() => ({
    first_name: { value: user.first_name || '', validators: ["required", "min:1"]},
    last_name: { value: user.last_name || '', validators: ["required", "min:1"]},
    company: { value: user.company || '', validators: ["required", "min:1"]},
    address: { value: user.address || '', validators: ["required", "min:1"]},
    city: { value: user.city || '', validators: ["required", "min:1"]},
    state: { value: user.state || '', validators: ["required", "min:1"]},
    postal_code: { value: user.postal_code || '', validators: ["required", "postal"]},
    phone: { value: user.phone || '', validators: ["required", "phone"]},
    email: { value: user.email || '', validators: ["required", "email"]},
    password: { value: user.password || '', validators: ["required", "min:5", "max:20"]},
    verify_password: { value: verifyPassword || '', validators: ["required", `equal:${user.password}`]},
    alert_phone: { value: user.alert_phone || '', validators: ["required", "phone"]},
    alert_email: { value: user.alert_email || '', validators: ["required", "email"]}
  }));


  // methods
  const save = async () => {
    try {
      showLoading(true);
      AppController.saveUserSettings(user);
      toast('success', 3000, 'Saved', 'Account info was saved successfully');
    } catch (err) {
      toast('danger', 'Error', 'An error occured saving account info.');
    } finally {
      showLoading(false);
    }
  }

  const cancel = () => {
    push('/app/residents');
  }
</script>
<div in:fade="{{duration: 1000}}">
  <SectionHeader section='Settings' subsection={subsection}>
  </SectionHeader>
  {#if user && userForm}
    <form class="forms-sample">
      <div class='row'>
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Company Info</h4>
              <div class='row'>
                <div class='col-md-6'>
                  <div class="form-group">
                    <label for="input-first-name" class='required-field'>First Name</label>
                    <input 
                      type="text" 
                      bind:value={user.first_name} 
                      use:validate={user.first_name}
                      class="form-control" 
                      class:border-danger={!$userForm.first_name.valid}
                      id="input-first-name" 
                      placeholder="First Name">
                    {#if $userForm.first_name.errors.includes('required')}
                      <p class='text-danger text-small'>First name is required</p>
                    {/if}
                  </div>
                </div>
                <div class='col-md-6'>
                  <div class="form-group">
                    <label for="input-last-name" class='required-field'>Last Name</label>
                    <input 
                      type="text" 
                      bind:value={user.last_name} 
                      use:validate={user.last_name}
                      class="form-control" 
                      class:border-danger={!$userForm.last_name.valid}
                      id="input-last-name" 
                      placeholder="Last Name">
                    {#if $userForm.last_name.errors.includes('required')}
                      <p class='text-danger text-small'>Last name is required</p>
                    {/if}
                  </div>
                </div>
              </div>
              <div class='row'>
                <div class='col-md-6'>
                  <div class="form-group">
                    <label for="input-company" class='required-field'>Company Name</label>
                    <input 
                      type="text" 
                      bind:value={user.company} 
                      use:validate={user.company}
                      class="form-control"
                      class:border-danger={!$userForm.company.valid} 
                      id="input-company" 
                      placeholder="Company Name">
                    {#if $userForm.company.errors.includes('required')}
                      <p class='text-danger text-small'>Company name is required</p>
                    {/if}
                  </div>
                </div>
                <div class='col-md-6'>
                  <div class="form-group">
                    <label for="input-address" class='required-field'>Address</label>
                    <input 
                      type="text" 
                      bind:value={user.address} 
                      use:validate={user.address}
                      class="form-control"
                      class:border-danger={!$userForm.address.valid} 
                      id="input-address" 
                      placeholder="Address">
                    {#if $userForm.address.errors.includes('required')}
                      <p class='text-danger text-small'>Address is required</p>
                    {/if}
                  </div>
                </div>
              </div>
              <div class='row'>
                <div class='col-md-4'>
                  <div class="form-group">
                    <label for="input-city" class='required-field'>City</label>
                    <input 
                      type="text" 
                      bind:value={user.city} 
                      use:validate={user.city}
                      class="form-control"
                      class:border-danger={!$userForm.city.valid} 
                      id="input-city" 
                      placeholder="City">
                    {#if $userForm.city.errors.includes('required')}
                      <p class='text-danger text-small'>City is required</p>
                    {/if}
                  </div>
                </div>
                <div class='col-md-4'>
                  <div class="form-group">
                    <label for="input-state" class='required-field'>State</label>
                    <input 
                      type="text" 
                      bind:value={user.state} 
                      use:validate={user.state}
                      class="form-control"
                      class:border-danger={!$userForm.state.valid} 
                      id="input-state" 
                      placeholder="State">
                    {#if $userForm.state.errors.includes('required')}
                      <p class='text-danger text-small'>State is required</p>
                    {/if}
                  </div>
                </div>
                <div class='col-md-4'>
                  <div class="form-group">
                    <label for="input-postal" class='required-field'>Postal Code</label>
                    <input 
                      type="text" 
                      bind:value={user.postal_code} 
                      use:validate={user.postal_code}
                      class="form-control" 
                      class:border-danger={!$userForm.postal_code.valid}
                      id="input-postal"
                      placeholder='Postal Code'>
                    {#if $userForm.postal_code.errors.includes('required') || $userForm.postal_code.errors.includes('postal')}
                      <p class='text-danger text-small'>Valid postal code is required (eg 55449 or 55449-9090)</p>
                    {/if}
                  </div>
                </div>
              </div>
              <div class='row'>
                <div class='col-md-4'>
                  <div class="form-group">
                    <label for="input-email" class='required-field'>Email</label>
                    <input 
                      type="text" 
                      bind:value={user.email} 
                      use:validate={user.email}
                      class="form-control"
                      class:border-danger={!$userForm.email.valid} 
                      id="input-email" 
                      placeholder="Email">
                    {#if $userForm.email.errors.includes('required')}
                      <p class='text-danger text-small'>Email is required</p>
                    {/if}
                  </div>
                </div>
                <div class='col-md-4'>
                  <div class="form-group">
                    <label for="input-password" class='required-field'>Password</label>
                    <input 
                      type="password" 
                      bind:value={user.password} 
                      use:validate={user.password}
                      class="form-control"
                      class:border-danger={!$userForm.password.valid} 
                      id="input-password" 
                      placeholder="Password">
                    {#if $userForm.password.errors.includes('required')}
                      <p class='text-danger text-small'>Password is required</p>
                    {/if}
                  </div>
                </div>
                <div class='col-md-4'>
                  <div class="form-group">
                    <label for="input-verify-password" class='required-field'>Verify Password</label>
                    <input 
                      type="password" 
                      bind:value={verifyPassword} 
                      use:validate={verifyPassword}
                      class="form-control" 
                      class:border-danger={!$userForm.verify_password.valid}
                      id="verify-password"
                      placeholder='Verify Password'>
                    {#if $userForm.verify_password.errors.includes('equal')}
                      <p class='text-danger text-small'>Password does not match</p>
                    {/if}
                  </div>
                </div>
              </div>
              <div class='row'>
                <div class='col-md-4'>
                  <div class="form-group">
                    <label for="input-phone" class='required-field'>Phone</label>
                    <input 
                      type="text" 
                      bind:value={user.phone} 
                      use:validate={user.phone}
                      class="form-control"
                      class:border-danger={!$userForm.phone.valid} 
                      id="input-phone" 
                      placeholder="Phone">
                    {#if $userForm.phone.errors.includes('phone')}
                      <p class='text-danger text-small'>Must be valid phone number or empty (eg 612-633-9090 or (612) 633-9090)</p>
                    {/if}
                  </div>
                </div>
                <div class='col-md-4'>
                  <div class="form-group">
                    <label for="timezone" class='required-field'>Timezone</label>
                    <select 
                      bind:value={user.timezone}
                      class="form-control" 
                      id="timezone">
                      <option value='America/Anchorage'>America/Anchorage</option>
                      <option value='America/Chicago'>America/Chicago</option>
                      <option value='America/Denver'>America/Denver</option>
                      <option value='Pacific/Honolulu'>Pacific/Honolulu</option>
                      <option value='America/Los_Angeles'>America/Los_Angeles</option>
                      <option value='America/New_York'>America/New_York</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>  
      </div>
      <div class='row mt-3'>
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Alert Config</h4>
              <div class='row'>
                <div class='col-md-6'>
                  <div class="form-group">
                    <label for="input-alert-email" class='required-field'>Email Alert From Email Address</label>
                    <input 
                      type="text" 
                      readonly
                      bind:value={user.alert_email} 
                      use:validate={user.alert_email}
                      class="form-control" 
                      class:border-danger={!$userForm.alert_email.valid}
                      id="input-alert-email" 
                      placeholder="Alert From Email Address">
                    {#if $userForm.alert_email.errors.includes('required')}
                      <p class='text-danger text-small'>Email Alert From Email is required</p>
                    {/if}
                  </div>
                </div>
                <div class='col-md-6'>
                  <div class="form-group">
                    <label for="input-alert-phone" class='required-field'>Voice Alert From Phone Number</label>
                    <input 
                      type="text" 
                      bind:value={user.alert_phone} 
                      use:validate={user.alert_phone}
                      class="form-control" 
                      class:border-danger={!$userForm.alert_phone.valid}
                      id="input-last-name" 
                      placeholder="Alert From Phone Number">
                    {#if $userForm.alert_phone.errors.includes('phone')}
                      <p class='text-danger text-small'>Must be valid phone number or empty (eg 612-633-9090 or (612) 633-9090)</p>
                    {/if}
                  </div>
                </div>
              </div>
              <div class='row'>
                <div class='col-md-6'>
                  <div class="form-group">
                    <label for="alert-voice" class='required-field'>Select Alert Voice</label>
                    <div class="form-check">
                      <input 
                        class="form-check-input" 
                        type="radio" 
                        name="alert-voice" 
                        id="alertVoice1" 
                        bind:group={user.alert_voice}
                        value={'MALE1'}>
                        <label class="form-check-label" for="alertVoice1">
                          Male Voice 1
                        </label>
                        <audio controls style="width: 100%;">
                          <source src="audio/Roger-male1-This-is-a-Public-Alert-We-have-a-sewer.mp3" type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio>
                    </div>
                    <div class="form-check">
                      <input 
                        class="form-check-input" 
                        type="radio" 
                        name="alert-voice" 
                        id="alertVoice2" 
                        bind:group={user.alert_voice}
                        value={"FEMALE1"}>
                        <label class="form-check-label" for="alertVoice1">
                          Female Voice 1
                        </label>
                        <audio controls style="width: 100%;">
                          <source src="audio/Mary-female1-This-is-a-Public-Alert-We-have-a-sewer.mp3" type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio>
                    </div>
                    <div class="form-check">
                      <input 
                        class="form-check-input" 
                        type="radio" 
                        name="alert-voice" 
                        id="alertVoice3" 
                        bind:group={user.alert_voice}
                        value={"FEMALE2"}>
                        <label class="form-check-label" for="alertVoice1">
                          Female Voice 2
                        </label>
                        <audio controls style="width: 100%;">
                          <source src="audio/Beth-female2-This-is-a-Public-Alert-We-have-a-sewer.mp3" type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio>
                    </div>
                    <div class="form-check">
                      <input 
                        class="form-check-input" 
                        type="radio" 
                        name="alert-voice" 
                        id="alertVoice4" 
                        bind:group={user.alert_voice}
                        value={"SPANISH1"}>
                        <label class="form-check-label" for="alertVoice1">
                          Female Voice 3 Spanish
                        </label>
                        <audio controls style="width: 100%;">
                          <source src="audio/Maria-femaleSpanish1-Esta-es-una-alerta-Tenemos-una-l-nea-de.mp3" type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio>
                    </div>
                    <div class="form-check">
                      <input 
                        class="form-check-input" 
                        type="radio" 
                        name="alert-voice" 
                        id="alertVoice5" 
                        value={"FRENCHCANADIAN1"}>
                        <label class="form-check-label" for="alertVoice1">
                          Female Voice 4 French
                        </label>
                        <audio controls style="width: 100%;">
                          <source src="audio/Helene - femaleFrench1-Ceci-est-un-avertissement-public-Nous-a.mp3" type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio>
                    </div>
                  </div>
                </div>
              </div>
              <div class='mt-2'>
                <button class="btn btn-secondary mr-2" on:click|preventDefault={cancel}>Cancel</button>
                <button class="btn btn-primary mr-2" class:disabled={!$userForm.valid} disabled={!$userForm.valid}  on:click|preventDefault={save}>Save</button>
              </div>
            </div>
          </div>
        </div>  
      </div>
    </form>
  {/if}
</div>

<style>
  .required-field::after {
    content: "*";
    color: red;
  }

  .border-light {
    border: 1px solid #f3f3f3;
  }

  .dropdown-menu {
    position: absolute;
    will-change: transform;
    overflow-anchor: auto;
    height: 200px;
    overflow-y: auto;
    top: 0px;
    left: 0px;
    transform: translate3d(0px, 46px, 0px);
  }
</style>